// src/auth/LoginSuccess.jsx
import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import useAuthStore from '../stores/authStore';

export default function LoginSuccess() {
  const { login } = useAuthStore();
  const navigate = useNavigate();
  const [params] = useSearchParams();

  useEffect(() => {
    // ✅ URLパラメータからJWTトークンを受け取る
    const access  = params.get('access');
    const refresh = params.get('refresh');
    const next    = params.get('next') || '/';

    if (!access || !refresh) {
      navigate('/login?err=oauth', { replace: true });
      return;
    }

    // ✅ JWTペイロードからユーザー情報を取得（DBアクセス不要）
    try {
      const payload = JSON.parse(atob(access.split('.')[1]));
      const WuserType    = payload.user_type || '';
      const WuserName    = payload.name      || '';
      const WuserAddress = payload.email     || '';
      const WaccountId   = payload.user_id   || '';

      login({
        access,
        refresh,
        WuserName,
        WuserType,
      });

      const nextTo =
        WuserType === 'system' ? '/admin/dashboard' :
        WuserType === 'admin'   ? '/admin/dashboard' :
        WuserType === 'operator'   ? '/operator/dashboard'  :
        '/enduser/dashboard';

      navigate(next !== '/' ? next : nextTo, { replace: true });

    } catch {
      navigate('/login?err=oauth', { replace: true });
    }
  }, [navigate, params, setUser]);

  return null;
}